(() => {
  const ROOT_SELECTOR = '[data-hr-product-vibe-owned]';
  const PRODUCT_ANCHOR_ID = 'Shop Now';
  const OPTION_RIDS = {
    6: '6c2189ee-0566-4b4d-b738-32291f58d35c',
    12: '882a0eff-3709-4269-bf89-55390ec6f877',
    24: '68e7c983-c9ac-4463-80b9-7d587fb0c374'
  };
  const OPTION_SELECTED_CLASSES = {
    6: 'r-zwixzw',
    12: 'r-te0yax',
    24: 'r-1g1o8i4'
  };
  const OFFER_TAGS = {
    6: {
      containerRid: '36e4026a-a503-45d2-946d-bde5f181f448',
      textRid: 'c6172bcd-a466-44f3-85fb-27fbaf5b9723',
      label: null
    },
    12: {
      containerRid: '275ac193-f2f9-412c-b269-65721af2fc39',
      textRid: 'c4f788ef-8a09-4b54-baff-6b3e07cb6e7e',
      label: 'Most Popular!'
    },
    24: {
      containerRid: '57fd15c9-146f-45ed-aca0-e21407d08c49',
      textRid: '29810076-e476-41cb-964f-e6f019be9aff',
      label: 'Best Value!'
    }
  };
  const PURCHASE_RIDS = {
    subscription: 'fdb9f2e7-6f2c-4a85-ad45-b87f7eca4675',
    oneTime: 'de0276ae-8eb1-4117-82a0-396183c5bee4'
  };
  const PURCHASE_SELECTED_CLASSES = {
    subscription: 'r-lhsymg',
    oneTime: 'r-16tifmg'
  };
  const SELLING_PLAN_RID = '3beeba39-5a47-40c2-ab7a-667a2e972770';
  const SUBSCRIPTION_TOTAL_PRICE_RID = '3f02df9c-5ec7-43f2-b7a7-f8efc54ae2d8';
  const ONE_TIME_PRICE_RID = '8a6507e3-f5ab-4e99-801d-a429686886f4';
  const UNIT_PRICE_RIDS = [
    '05b89df6-1b9c-4956-8916-4e1ec77f9881',
    'a86a7511-a6da-4495-a7df-13d03d0c4ba2',
    '32af4118-f7c0-4627-877a-ca8d8eee31e2'
  ];
  const ATC_RID = '3dee0306-aa11-402b-b3a9-2f5788301a3a';
  const ATC_LABEL_RID = '1e8c0160-4a1d-4524-b502-2306332c5ab6';
  const SHOP_NOW_RIDS = [
    '879ac418-0eb8-4e8d-9418-f15b2160368e',
    'ec87c7d3-a4be-4396-a819-1aa6eeaedbfa',
    'e5d0e0ec-183f-4d78-a2b4-5c88e2ec09c5',
    'd57d6177-0fde-4d70-901c-f48c25af9d77'
  ];

  const byRid = (root, rid) => root.querySelector(`[data-rid="${rid}"]`);
  const allByRid = (root, rid) => [...root.querySelectorAll(`[data-rid="${rid}"]`)];

  const parseConfig = (root) => {
    const node = root.querySelector('[data-hr-product-vibe-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('High Rider: invalid Vibe product configuration.', error);
      return null;
    }
  };

  const bindKeyboardActivation = (element, activate) => {
    if (!element || element.matches('button, a[href], input, select, textarea')) return;
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      activate();
    });
  };

  const textTarget = (element) => element?.querySelector('p')
    || element?.querySelector(':scope > span')
    || element;

  const setText = (root, rid, value) => {
    allByRid(root, rid).forEach((element) => {
      const target = textTarget(element);
      if (target) target.textContent = value;
    });
  };

  const initializeOfferTags = (root) => {
    Object.values(OFFER_TAGS).forEach(({ containerRid, textRid, label }) => {
      allByRid(root, containerRid).forEach((container) => {
        container.hidden = !label;
        container.setAttribute('aria-hidden', String(!label));
      });
      if (label) setText(root, textRid, label);
    });
  };

  const formatMoney = (cents, format = '${{amount}}') => {
    const value = Number(cents || 0);
    const withDelimiter = (number, precision, thousands, decimal) => {
      const fixed = (number / 100).toFixed(precision);
      const [whole, fraction] = fixed.split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${grouped}${decimal}${fraction}` : grouped;
    };
    const key = format.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator|_with_space_separator)?)\s*\}\}/)?.[1];
    const replacements = {
      amount: withDelimiter(value, 2, ',', '.'),
      amount_no_decimals: withDelimiter(value, 0, ',', '.'),
      amount_with_comma_separator: withDelimiter(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiter(value, 0, '.', ','),
      amount_with_space_separator: withDelimiter(value, 2, ' ', ','),
      amount_no_decimals_with_space_separator: withDelimiter(value, 0, ' ', ',')
    };
    if (!key) return `$${replacements.amount}`;
    return format.replace(/\{\{\s*[^}]+\s*\}\}/, replacements[key] || replacements.amount);
  };

  const initializeCarousel = (root, gallery) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel || !Array.isArray(gallery) || !gallery.length) return;

    const tracks = [...carousel.querySelectorAll('[data-replo-part="slide-track"]')];
    const mainTrack = tracks.find((track) => track.dataset.reploRootId?.includes('R17msj2')) || tracks[0];
    const thumbnailTrack = tracks.find((track) => track.dataset.reploRootId?.includes('Rbmsj2')) || tracks[1];
    const mainTemplate = mainTrack?.querySelector('[data-replo-part="slide"]');
    const thumbnailTemplate = thumbnailTrack?.querySelector('[data-replo-part="slide"]');
    if (!mainTrack || !mainTemplate) return;

    const makeSlide = (template, media, index, thumbnail = false) => {
      const slide = template.cloneNode(true);
      slide.id = `hr-product-vibe-${thumbnail ? 'thumbnail' : 'slide'}-${index + 1}`;
      slide.dataset.slideIndex = String(index);
      slide.dataset.slideSourceIndex = String(index);
      slide.dataset.isActive = String(index === 0);
      slide.dataset.hrProductVibeGeneratedSlide = 'true';
      slide.removeAttribute('data-is-cloned');
      slide.setAttribute('aria-hidden', String(!thumbnail && index !== 0));
      slide.setAttribute('aria-label', `${thumbnail ? 'Show product image' : 'Slide'} ${index + 1}${thumbnail ? '' : ` of ${gallery.length}`}`);
      slide.tabIndex = thumbnail ? 0 : (index === 0 ? 0 : -1);
      if (thumbnail) slide.setAttribute('role', 'button');

      slide.querySelectorAll('source').forEach((source) => { source.srcset = media.url; });
      slide.querySelectorAll('img').forEach((image) => {
        image.src = media.url;
        image.removeAttribute('srcset');
        image.alt = media.alt || '';
        image.loading = index === 0 ? 'eager' : 'lazy';
      });
      slide.querySelectorAll('picture').forEach((picture) => {
        picture.style.setProperty('--replo-attributes-currentitem', `url("${media.url}")`);
      });
      return slide;
    };

    const mainSlides = gallery.map((media, index) => makeSlide(mainTemplate, media, index));
    const thumbnailSlides = thumbnailTemplate
      ? gallery.map((media, index) => makeSlide(thumbnailTemplate, media, index, true))
      : [];
    mainTrack.replaceChildren(...mainSlides);
    thumbnailTrack?.replaceChildren(...thumbnailSlides);

    const status = carousel.querySelector('[aria-live="polite"]');
    const previous = carousel.querySelector('[data-direction="previous"]');
    const next = carousel.querySelector('[data-direction="next"]');
    let activeIndex = 0;
    let touchStartX = null;

    const setActive = (nextIndex, animate = true) => {
      activeIndex = (nextIndex + mainSlides.length) % mainSlides.length;
      mainSlides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.dataset.isActive = String(active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      mainTrack.style.transitionDuration = animate ? '320ms' : '0ms';
      mainTrack.style.transitionProperty = 'transform';
      mainTrack.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
      thumbnailSlides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.dataset.isActive = String(active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        slide.querySelector('[data-rid="e21d6d18-8622-4bb6-b4b5-55953542cbc1"]')
          ?.classList.toggle('r-1kiewnr', active);
      });
      if (status) status.textContent = `Slide ${activeIndex + 1} of ${mainSlides.length}`;
      previous?.toggleAttribute('disabled', mainSlides.length < 2);
      next?.toggleAttribute('disabled', mainSlides.length < 2);
    };

    previous?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));
    thumbnailSlides.forEach((slide, index) => {
      const activate = () => setActive(index);
      slide.addEventListener('click', activate);
      bindKeyboardActivation(slide, activate);
    });
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
      if (event.key === 'ArrowRight') setActive(activeIndex + 1);
    });
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) >= 40) setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    setActive(0, false);
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible]').forEach((collapsible) => {
      if (collapsible.dataset.hrProductVibeBound === 'true') return;
      const trigger = collapsible.querySelector('[role="button"][aria-controls]');
      const content = trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
      if (!trigger || !content || !root.contains(content)) return;
      collapsible.dataset.hrProductVibeBound = 'true';
      const setOpen = (open) => {
        collapsible.dataset.state = open ? 'open' : 'closed';
        trigger.dataset.state = open ? 'open' : 'closed';
        trigger.setAttribute('aria-expanded', String(open));
        content.hidden = !open;
      };
      const toggle = () => setOpen(trigger.getAttribute('aria-expanded') !== 'true');
      trigger.addEventListener('click', toggle);
      bindKeyboardActivation(trigger, toggle);
      setOpen(trigger.getAttribute('aria-expanded') === 'true' && !content.hidden);
    });
  };

  const initializeLinks = (root, config) => {
    const productLinks = {
      'd3864623-0cc2-468f-beb2-0130b5e9746e': config.routes.rush,
      '59c6780d-e1c3-4b18-b81b-c0af890ce4d0': config.routes.orbit
    };
    Object.entries(productLinks).forEach(([rid, href]) => {
      const element = byRid(root, rid);
      if (!element || !href) return;
      if (element.matches('a')) {
        element.href = href;
        element.removeAttribute('role');
      } else {
        element.setAttribute('role', 'link');
        const activate = () => { window.location.href = href; };
        element.addEventListener('click', activate);
        bindKeyboardActivation(element, activate);
      }
    });

    const scrollToProduct = () => document.getElementById(PRODUCT_ANCHOR_ID)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    SHOP_NOW_RIDS.forEach((rid) => {
      const element = byRid(root, rid);
      element?.addEventListener('click', scrollToProduct);
      bindKeyboardActivation(element, scrollToProduct);
    });

    const backToTop = byRid(root, 'cec9a022-fe34-450e-8e38-607b055e5116');
    const returnToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
    backToTop?.addEventListener('click', returnToTop);
    bindKeyboardActivation(backToTop, returnToTop);

    root.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
      badge.setAttribute('role', 'link');
      badge.tabIndex = 0;
      const activate = () => document.getElementById('judgeme_product_reviews')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      badge.addEventListener('click', activate);
      bindKeyboardActivation(badge, activate);
    });
  };

  const initializeProductForm = (root, config) => {
    const variants = Array.isArray(config.variants) ? config.variants : [];
    const optionNodes = Object.entries(OPTION_RIDS)
      .map(([size, rid]) => ({ size: Number(size), element: byRid(root, rid) }))
      .filter(({ element }) => element);
    const subscribeCard = byRid(root, PURCHASE_RIDS.subscription);
    const oneTimeCard = byRid(root, PURCHASE_RIDS.oneTime);
    const planSelect = byRid(root, SELLING_PLAN_RID);
    const atcButton = byRid(root, ATC_RID);
    const sourceForm = root.querySelector('form[action*="/cart/add"]');
    const variantInput = sourceForm?.querySelector('[name="id"]');
    const quantityInput = sourceForm?.querySelector('[name="quantity"]');
    const sellingPlanInput = sourceForm?.querySelector('[name="selling_plan"]');
    const errorNode = root.querySelector('[data-hr-product-vibe-error]');
    if (!variants.length || !optionNodes.length || !atcButton || !variantInput) return;

    const requestedId = Number(new URL(window.location.href).searchParams.get('variant'));
    let selectedVariant = variants.find((variant) => variant.id === requestedId)
      || variants.find((variant) => variant.id === config.defaultVariantId)
      || variants.find((variant) => variant.available)
      || variants[0];
    let selectedFlavor = selectedVariant.flavor;
    if (!OPTION_RIDS[selectedVariant.bundleSize]) {
      selectedVariant = variants.find((variant) => variant.flavor === selectedFlavor && variant.bundleSize === 12)
        || variants.find((variant) => OPTION_RIDS[variant.bundleSize] && variant.available)
        || selectedVariant;
    }
    let purchaseMode = selectedVariant.sellingPlans?.length ? 'subscription' : 'one-time';
    let selectedPlanId = selectedVariant.sellingPlans?.[0]?.id || null;
    let loading = false;

    const planForVariant = () => selectedVariant.sellingPlans?.find((plan) => plan.id === Number(selectedPlanId))
      || selectedVariant.sellingPlans?.[0]
      || null;

    const variantForBundle = (bundleSize) => variants.find((variant) => (
      variant.flavor === selectedFlavor && variant.bundleSize === Number(bundleSize)
    )) || variants.find((variant) => variant.bundleSize === Number(bundleSize));

    const syncPlans = () => {
      if (!planSelect) return;
      const plans = selectedVariant.sellingPlans || [];
      if (!plans.some((plan) => plan.id === Number(selectedPlanId))) selectedPlanId = plans[0]?.id || null;
      planSelect.replaceChildren(...plans.map((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = plan.name;
        option.selected = plan.id === Number(selectedPlanId);
        return option;
      }));
      planSelect.disabled = purchaseMode !== 'subscription' || !plans.length;
      planSelect.setAttribute('aria-label', 'Delivery frequency');
    };

    const syncPurchaseCards = () => {
      const hasPlans = Boolean(selectedVariant.sellingPlans?.length);
      if (!hasPlans) purchaseMode = 'one-time';
      [subscribeCard, oneTimeCard].forEach((card) => {
        Object.values(PURCHASE_SELECTED_CLASSES).forEach((className) => card?.classList.remove(className));
      });
      const selectedCard = purchaseMode === 'subscription' ? subscribeCard : oneTimeCard;
      selectedCard?.classList.add(PURCHASE_SELECTED_CLASSES[purchaseMode === 'subscription' ? 'subscription' : 'oneTime']);
      if (subscribeCard) {
        subscribeCard.dataset.hrSelected = String(purchaseMode === 'subscription');
        subscribeCard.setAttribute('aria-pressed', String(purchaseMode === 'subscription'));
        subscribeCard.setAttribute('aria-disabled', String(!hasPlans));
      }
      if (oneTimeCard) {
        oneTimeCard.dataset.hrSelected = String(purchaseMode === 'one-time');
        oneTimeCard.setAttribute('aria-pressed', String(purchaseMode === 'one-time'));
      }
      root.querySelectorAll(`input[type="radio"][value^="${PURCHASE_RIDS.subscription}."]`)
        .forEach((radio) => { radio.checked = purchaseMode === 'subscription'; });
      root.querySelectorAll(`input[type="radio"][value^="${PURCHASE_RIDS.oneTime}."]`)
        .forEach((radio) => { radio.checked = purchaseMode === 'one-time'; });
    };

    const render = () => {
      const plan = planForVariant();
      variantInput.value = String(selectedVariant.id);
      if (quantityInput) quantityInput.value = quantityInput.value || '1';
      if (sellingPlanInput) {
        sellingPlanInput.value = purchaseMode === 'subscription' && plan ? String(plan.id) : '';
      }

      optionNodes.forEach(({ size, element }) => {
        const candidate = variantForBundle(size);
        const selected = size === selectedVariant.bundleSize;
        Object.values(OPTION_SELECTED_CLASSES).forEach((className) => element.classList.remove(className));
        if (selected) element.classList.add(OPTION_SELECTED_CLASSES[size]);
        element.dataset.hrSelected = String(selected);
        element.dataset.hrAvailable = String(Boolean(candidate?.available));
        element.setAttribute('aria-selected', String(selected));
        element.setAttribute('aria-disabled', String(!candidate?.available));
        element.setAttribute('aria-label', `${size} bottles${candidate?.available ? '' : ', sold out'}`);
        element.tabIndex = selected ? 0 : -1;
      });

      syncPurchaseCards();
      syncPlans();
      setText(root, SUBSCRIPTION_TOTAL_PRICE_RID, formatMoney(plan?.price || selectedVariant.price, config.moneyFormat));
      setText(root, ONE_TIME_PRICE_RID, formatMoney(selectedVariant.price, config.moneyFormat));
      const unitPrice = Math.round((plan?.price || selectedVariant.price) / Math.max(1, selectedVariant.bundleSize));
      UNIT_PRICE_RIDS.forEach((rid) => setText(root, rid, `${formatMoney(unitPrice, config.moneyFormat)} ea.`));

      const purchasable = Boolean(selectedVariant.available) && !loading;
      atcButton.disabled = !purchasable;
      atcButton.setAttribute('aria-disabled', String(!purchasable));
      setText(root, ATC_LABEL_RID, selectedVariant.available ? config.addToCartLabel : config.soldOutLabel);
    };

    const selectBundle = (bundleSize, updateUrl = true) => {
      const candidate = variantForBundle(bundleSize);
      if (!candidate) return;
      selectedVariant = candidate;
      selectedFlavor = candidate.flavor;
      selectedPlanId = candidate.sellingPlans?.[0]?.id || null;
      render();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(candidate.id));
        window.history.replaceState({}, '', url);
      }
    };

    optionNodes.forEach(({ size, element }, index) => {
      element.addEventListener('click', () => selectBundle(size));
      element.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectBundle(size);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          optionNodes[(index + 1) % optionNodes.length].element.focus();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          optionNodes[(index + optionNodes.length - 1) % optionNodes.length].element.focus();
        }
      });
    });

    const selectSubscription = () => {
      if (!selectedVariant.sellingPlans?.length) return;
      purchaseMode = 'subscription';
      selectedPlanId ||= selectedVariant.sellingPlans[0].id;
      render();
    };
    const selectOneTime = () => {
      purchaseMode = 'one-time';
      render();
    };
    subscribeCard?.addEventListener('click', selectSubscription);
    oneTimeCard?.addEventListener('click', selectOneTime);
    bindKeyboardActivation(subscribeCard, selectSubscription);
    bindKeyboardActivation(oneTimeCard, selectOneTime);
    planSelect?.addEventListener('change', () => {
      selectedPlanId = Number(planSelect.value);
      render();
    });

    const setLoading = (nextLoading) => {
      loading = nextLoading;
      let indicator = atcButton.querySelector('.hr-product-vibe-loading');
      if (!indicator) {
        indicator = document.createElement('span');
        indicator.className = 'hr-product-vibe-loading';
        indicator.setAttribute('aria-hidden', 'true');
        indicator.innerHTML = '<span>LOADING</span><span class="hr-product-vibe-spinner"></span>';
        atcButton.appendChild(indicator);
      }
      atcButton.dataset.hrLoading = String(nextLoading);
      atcButton.setAttribute('aria-busy', String(nextLoading));
      render();
    };

    const openCart = async (state) => {
      for (let attempt = 0; attempt < 600; attempt += 1) {
        if (typeof window.EliteCart?.openDrawerWithDataRefresh === 'function') {
          await window.EliteCart.openDrawerWithDataRefresh();
          return true;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      const cartSurface = document.querySelector('cart-drawer, cart-notification');
      if (typeof cartSurface?.renderContents === 'function' && state.sections) {
        cartSurface.renderContents(state);
        return true;
      }
      return false;
    };

    const addToCart = async () => {
      const plan = planForVariant();
      if (loading || !selectedVariant.available) return;
      if (errorNode) errorNode.hidden = true;
      setLoading(true);

      const formData = new FormData();
      formData.append('id', String(selectedVariant.id));
      formData.append('quantity', quantityInput?.value || '1');
      if (purchaseMode === 'subscription' && plan) formData.append('selling_plan', String(plan.id));
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', `${window.location.pathname}${window.location.search}`);

      try {
        const response = await fetch(config.routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');

        document.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          detail: {
            productId: config.productId,
            variantId: selectedVariant.id,
            sellingPlanId: purchaseMode === 'subscription' ? plan?.id || null : null,
            cartData: state
          }
        }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hr-product-vibe-owned', cartData: state, variantId: selectedVariant.id
          });
        }

        if (!await openCart(state)) window.location.assign(config.routes.cart || '/cart');
      } catch (error) {
        console.error('High Rider: Vibe add to cart failed.', error);
        if (errorNode) {
          errorNode.textContent = error?.message || 'Unable to add this item. Please try again.';
          errorNode.hidden = false;
          atcButton.insertAdjacentElement('afterend', errorNode);
        }
      } finally {
        setLoading(false);
      }
    };

    atcButton.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });
    sourceForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart();
    });
    render();
  };

  const initialize = (root) => {
    if (root.dataset.hrProductVibeInitialized === 'true') return;
    const config = parseConfig(root);
    if (!config) return;
    root.dataset.hrProductVibeInitialized = 'true';
    initializeOfferTags(root);
    initializeCarousel(root, config.gallery);
    initializeCollapsibles(root);
    initializeLinks(root, config);
    initializeProductForm(root, config);
    window.jdgm?.initializeWidgets?.();
  };

  const initializeAll = (container = document) => {
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
